module.exports = __webpack_public_path__ + "static/media/ciscoEdit.08c1f336.svg";